// dd/mm/yyyy hh:ss
const mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
